export const NOTIFICATION_TYPES = {
  COMMENT: "comment",
  NEW_FRIEND_REQUEST: "new friend request",
  ACCEPED_FRIEND_REQUEST: "accepted friend request",
};

export const FRIEND_REQUEST_STATUSES = {
  APPROVED: "approved",
  INCOMING: "incoming",
  OUTGOING: "outgoing",
};

export const MAX_CONTENT_WIDTH = "1200";
